<template>
  <div>
    <Hero :name="'Usuarios'">
      <div class="field">
        <div class="control">
          <input
            class="input is-medium"
            v-model="search"
            type="text"
            placeholder="Buscar..."
          />
        </div>
      </div>
    </Hero>

    <section style="display:grid;">
      <div class="table-container">
        <table class="table is-bordered is-narrow is-fullwidth">
          <thead>
            <tr>
              <th>Id</th>
              <th>Nombre</th>
              <th class="is-hidden-mobile">Email</th>
              <th>created_at</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="usuario in users.data" v-bind:key="usuario.id">
              <td>{{ usuario.id }}</td>
              <td>{{ usuario.name }}</td>
              <td class="is-hidden-mobile">{{ usuario.email }}</td>
              <td>{{ usuario.created_at }}</td>
              <td><button class="button is-small">Ver</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/Hero";
import { mapState } from "vuex";

export default {
  components: { Hero },
  name: "Usuarios",

  data() {
    return {
      search: ""
    };
  },
  created() {
    this.$store.dispatch("user/fetchUsers");
  },
  computed: mapState("user", ["users"])
};
</script>

<style lang="css" scoped></style>
